<div class="custom-dialog" [class.md]="className == 'md'">
    <div class="header" *ngIf="title">
        <span>{{title}}</span>
        <span class="close" (click)="onRejection()">x</span>
    </div>

    <div *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</div>

    <div class="label">{{label}}</div>

    <div class="footer" *ngIf="!hideFooter">  
        <app-button [label]="confirmationText" class="save-btn" className="primary-alt" [showSpinner]="showSpinner" (onClick)="onConfirmation()"></app-button>
        <app-button [label]="rejectionText" class="cancel-btn" className="secondary-alt" (onClick)="onRejection()"></app-button>
    </div>
    </div>